<template>
<div class="card match-height">
    <div class="card-body px-0 py-75">
        <form action="#">
            <div class="row justify-content-center mx-auto" v-if="userStore.user && userStore.user.identity_iq">
                <div class="col-md-4 col-lg-4 col-sm-4">
                    <div class="form-group">
                        <label for="iqusername">IdentityIQ Username/Email</label>
                        <input
                            type="text"
                            class="form-control border-primary border-darken-1"
                            id="iqusername"
                            name="iqusername"
                            v-model="userStore.user.identity_iq.username"
                            placeholder="IdentityIQ Username/Email"
                        />
                    </div>
                </div>
                <div class="col-md-4 col-lg-4 col-sm-4">
                    <div class="form-group">
                        <label for="iqpassword">IdentityIQ Password</label>
                        <input
                            type="password"
                            class="form-control border-primary border-darken-1"
                            id="iqpassword"
                            name="iqpassword"
                            v-model="userStore.user.identity_iq.password"
                            placeholder="IdentityIQ Password"
                        />
                    </div>
                </div>
                <div class="col-md-3 col-lg-3 col-sm-3">
                    <div class="form-group">
                        <label for="iq_security_answer">
                            {{ localizationStore.translate("identity.security.answer.text.label") }}
                        </label>
                        <input
                            type="password"
                            class="form-control border-primary border-darken-1"
                            id="iq_security_answer"
                            name="iq_security_answer"
                            v-model="userStore.user.identity_iq.security_answer"
                            placeholder="Partial SSN"
                        />
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="form-group text-center mb-0 d-flex flex-sm-row flex-column justify-content-center">
                        <button type="button" :disabled='isLoading.update' @click="updateCredentials" class="btn btn-primary mr-md-1 mb-1 mb-sm-0">
                            <span>
                                {{ localizationStore.translate("save") }}
                            </span>
                        </button>
                        <button type="button" :disabled='isLoading.getreport' @click="getReport" value="0" data-type="1" class="btn btn-outline-primary waves-effect ">
                            <span v-show="!isLoading.getreport">
                                <i data-feather="bar-chart-2" class="mr-25"></i>
                                <span>
                                    {{ localizationStore.translate("identity.credentials.update.report.button.text") }}
                                </span>
                            </span>
                            <span v-show="isLoading.getreport">
                                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                <span class="ml-25 align-middle">
                                    {{ localizationStore.translate("identity.credentials.update.report.button.text.updating") }}
                                </span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
</template>
<style>
    .swal2-html-container {
        overflow: hidden;
    }
</style>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
    import { useUserStore } from '../../../stores/UserStore.js'
    import Swal from 'sweetalert2'
    export default {
        mounted() {
        },
        setup() {
            return {
                localizationStore: useLocalizationStore(),
                userStore: useUserStore(),
                isLoading: reactive({
                    update: false,
                    getreport: false
                }),
                status: ref(0)
            }
        },
        methods: {
            updateCredentials() {
                const $this = this;
                $this.isLoading.update = true;
                
                const route = this.$router.resolve(
                    {
                        name: 'identity-iq',
                        params: {
                            client: this.$route.params.client,
                            team: this.$route.params.team
                        }
                    }
                ).href;
                axios.post(route, {
                    iqusername: this.userStore.user.identity_iq.username,
                    iqpassword: this.userStore.user.identity_iq.password,
                    iq_security_answer: this.userStore.user.identity_iq.security_answer
                })
                .then(function (response) {
                    $this.isLoading.update = false;
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                })
                .catch(function (error) {
                    $this.isLoading.update = false;
                    toastr.error(error.response.statusText, 'Error!');
                });
            },
            getReport() {
                const $this = this;
                this.isLoading.getreport = true;
                const route = this.$router.resolve(
                    {
                        name: 'getreport',
                        params: {
                            client: this.$route.params.client,
                            team: this.$route.params.team
                        }
                    }
                ).href;
                axios.get(
                    route,
                    {
                        params: {
                            type: 1
                        }
                    },
                ).then(function(response) {
                    // $this.isLoading.getreport = false;
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                }).catch(function(error) {
                    // $this.isLoading.getreport = false;
                    toastr.error(error.response.statusText, 'Error!');
                });return;
                Swal.fire({
                    title: 'Fetching Report',
                    html: `
                        <p class="mb-0 d-flex justify-content-center align-items-center">
                            <span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span>
                            Connecting to IdentityIQ
                        </p>
                        <p class="mb-0">
                            Accessing Report Data
                        </p>
                        <p class="mb-0">
                            Auto Import Running
                        </p>
                    `,
                    showConfirmButton: false,
                    allowOutsideClick: true
                });
                setTimeout(() => {
                    this.status = 1;
                    Swal.getHtmlContainer().innerHTML = `
                        <p class="mb-0">
                            Connected to IdentityIQ
                        </p>
                        <p class="mb-0 d-flex justify-content-center align-items-center">
                            <span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span>
                            Accessing Report Data
                        </p>
                        <p class="mb-0">
                            Auto Import Running
                        </p>
                    `;
                }, 3000)
                setTimeout(() => {
                    this.status = 2;
                    Swal.getHtmlContainer().innerHTML = `
                        <p class="mb-0">
                            Connected to IdentityIQ
                        </p>
                        <p class="mb-0">
                            Report Data Accessed
                        </p>
                        <p class="mb-0 d-flex justify-content-center align-items-center">
                            <span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span>
                            Auto Import Running
                        </p>
                    `;
                }, 6000)
                setTimeout(() => {
                    this.status = 3;
                    Swal.getHtmlContainer().innerHTML = `
                        <p class="mb-0">
                            Connected to IdentityIQ
                        </p>
                        <p class="mb-0">
                            Report Data Accessed
                        </p>
                        <p class="mb-0">
                            Auto Import Done
                        </p>
                    `;
                }, 9000)
            }
        }
    }
</script>
